module.exports = __webpack_public_path__ + "img/tijian.cfd6dd6e.png";